import React from "react";
import { Card } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";

const MemoryHealth = ({ health }) => {
  if (!health) return null;

  const used = health?.usedMB ?? 0;
  const free = health?.freeMB ?? 0;
  const total = health?.totalMB ?? used + free;
  const max = health?.maxMB ?? total;

  // Remaining capacity is max - total (JVM can still grow up to max)
  const remaining = Math.max(max - total, 0);

  const usedPercent = max > 0 ? (used / max) * 100 : 0;

  const data = {
    labels: ["Used MB", "Free MB", "Remaining MB"],
    datasets: [
      {
        data: [used, free, remaining],
        backgroundColor: ["#FF6384", "#36A2EB", "#E0E0E0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#E0E0E0"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "70%",
    plugins: {
      legend: { position: "bottom" },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value =
              typeof context.raw === "number"
                ? context.raw
                : Number(context.raw);
            return `${context.label}: ${value.toLocaleString()} MB`;
          },
        },
      },
    },
  };

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>Memory</Card.Title>
      </Card.Header>
      <Card.Body className="d-flex justify-content-center align-items-center flex-column">
        <div style={{ width: "250px" }}>
          <Doughnut data={data} options={options} />
        </div>
        <div className="mt-3 text-center">
          <h5>{usedPercent.toFixed(1)}%</h5>
          <small>
            Used: {used.toLocaleString()} MB / Total: {total.toLocaleString()}{" "}
            MB / Max: {max.toLocaleString()} MB
          </small>
        </div>
      </Card.Body>
      <Card.Footer>
        <small className="d-flex">
          Status:{" "}
          <div
            className={`ms-2 me-2 circle ${
              health.status === "UP"
                ? "pulse green"
                : health.status === "DOWN"
                ? "red"
                : "blue"
            }`}
          ></div>
        </small>
      </Card.Footer>
    </Card>
  );
};

export default MemoryHealth;
